"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Send = function Send(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M17.653 4.565a.408.408 0 01.605.43l-2.347 12.232a.493.493 0 01-.646.37l-3.653-1.368-1.557 3.114a.29.29 0 01-.549-.13v-3.33c.004-.286.101-.562.278-.786.203-.231 5.97-7.778 5.97-7.778s-7.725 6.902-8.028 7.148a.95.95 0 01-.914.176L3.528 13.52a.406.406 0 01-.07-.736l14.195-8.219z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Send);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Send, "Send", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Send.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Send.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9TZW5kLnRzeCJdLCJuYW1lcyI6WyJTZW5kIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLElBQW9FLEdBQUcsU0FBdkVBLElBQXVFLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQzNFO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLENBQUMsRUFBQyxzUkFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixDQUQyRTtBQUFBLENBQTdFOztlQVNlLHVCQUFXRixJQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLEkiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IFNlbmQ6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk0xNy42NTMgNC41NjVhLjQwOC40MDggMCAwMS42MDUuNDNsLTIuMzQ3IDEyLjIzMmEuNDkzLjQ5MyAwIDAxLS42NDYuMzdsLTMuNjUzLTEuMzY4LTEuNTU3IDMuMTE0YS4yOS4yOSAwIDAxLS41NDktLjEzdi0zLjMzYy4wMDQtLjI4Ni4xMDEtLjU2Mi4yNzgtLjc4Ni4yMDMtLjIzMSA1Ljk3LTcuNzc4IDUuOTctNy43NzhzLTcuNzI1IDYuOTAyLTguMDI4IDcuMTQ4YS45NS45NSAwIDAxLS45MTQuMTc2TDMuNTI4IDEzLjUyYS40MDYuNDA2IDAgMDEtLjA3LS43MzZsMTQuMTk1LTguMjE5elwiXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoU2VuZCk7XG4iXX0=